/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IActionContext } from '@msdyn365-commerce/core';
import { updateAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { Cart } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

import { ICartActionResultWithCart } from './cart-action-result';

export default async function updateCart(cart: Readonly<Cart | undefined>, updatedCartObject: Cart, actionContext: IActionContext): Promise<ICartActionResultWithCart> {
    if (!cart) {
        return { cart: undefined, status: 'FAILED' };
    }

    return updateAsync(
        { callerContext: actionContext },
        { ...updatedCartObject, Id: cart.Id }
    )
        .then(newCart => {
            return <ICartActionResultWithCart>{ cart: newCart, status: 'SUCCESS' };
        })
        .catch(error => {
            actionContext.telemetry.warning(error);
            actionContext.telemetry.debug('Unable to update the cart');

            return <ICartActionResultWithCart>{ cart: undefined, status: 'FAILED' };
        });
}
